'use client';
import { useAppSelector } from 'lib/hooks';
import { RootState } from 'lib/store';
import { useState } from 'react';
import { selectUserDynamicValues } from 'slices/dynamicDataSelectors';
import { UserDynamicValues } from 'types/user';
import { contentWithData } from 'utils/content';

interface SupplementalInformationProps {
  staticText?: boolean;
  supplementalInformation: string;
}

// to-do: clean-up Kentico empty richtext elements
const SupplementalInformation = ({
  staticText,
  supplementalInformation,
}: SupplementalInformationProps) => {
  const [isActive, setIsActive] = useState(false);
  const readMore = () => setIsActive(!isActive);
  const userData = useAppSelector((state: RootState) =>
    selectUserDynamicValues(state)
  ) as UserDynamicValues;

  const filteredSupplementalInformation = () => {
    return supplementalInformation;
  };

  const information = filteredSupplementalInformation();

  if (staticText) {
    return (
      (information !== '<p><br></p>' && (
        <div>
          <span className={'expand'}>
            {contentWithData(information, userData)}
          </span>
        </div>
      )) ||
      null
    );
  }

  return (
    (information !== '<p><br></p>' && (
      <div>
        <span
          className={
            information.length >= 250 && !isActive ? 'read-more' : 'expand'
          }
        >
          {contentWithData(information, userData)}
        </span>
        {information.length >= 250 && (
          <button
            aria-expanded={isActive}
            className="btn outlined btn-small"
            data-testid="read-more-less"
            onClick={readMore}
          >
            {isActive ? 'Read less' : 'Read more'}
          </button>
        )}
      </div>
    )) ||
    null
  );
};

export default SupplementalInformation;
